import './Bio.css';

function Bio() {
  return (
    <div className="Bio">
      <p>
        I’m a Cloud Security Architect at Cisco focused on securing AI and LLM-enabled systems. I define technical security requirements for LLM usage and infrastructure across customer-facing products, build proof-of-concept exploits to validate risks, and brief leadership while guiding engineering teams to implement durable mitigations.
      </p>
      <p>
        Previously, I led Detection Engineering at Cisco Meraki, where I established the function from the ground up and delivered a Detection-as-Code pipeline using Sigma, Terraform, GitLab, and Splunk. Earlier roles included Security Operations (incident response, SIEM pipelines, correlation rule design) and DevOps engineering, shipping cloud-native apps and IaC with strong security testing.
      </p>
      <p>
        My background includes applied security research at NC State on the intersection of policy, privacy, and ML/NLP, with peer‑reviewed publications, and an early data science internship at the NSA. I enjoy turning research-grade ideas into production-ready defenses.
      </p>
      <p>
        AI security matters because LLMs expand the attack surface and concentrate risk: model supply chains, data exfiltration via prompts, over‑permissive tools, and prompt‑borne logic flaws can all become paths to business impact. I’m working to make AI trustworthy by bringing rigorous threat modeling, guardrails, and verification to every layer—from models and orchestration to apps and operations.
      </p>
    </div>
  );
}

export default Bio;
